import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/(sub-layout)/exchange/@section4/page.tsx");
